export class ToothProblemModel {
    pet_no: number
    problem_index: string
    tooth_no: string
    category_index: string
    category_name: string
    problem_name: string
    code_no: string
    code_name: string

    constructor(
        pet_no: number,
        problem_index: string,
        tooth_no: string,
        category_index: string,
        category_name: string,
        problem_name: string,
        code_no: string,
        code_name: string
    ) {
        this.pet_no = pet_no
        this.problem_index = problem_index
        this.tooth_no = tooth_no
        this.category_index = category_index
        this.category_name = category_name
        this.problem_name = problem_name
        this.code_no = code_no
        this.code_name = code_name
    }
}